import { ID } from '@ianesthesie-kit/services';
import { PregnancyInfo } from './pregnancyInfo.model';
import { PatchableMedicalService } from '../patchableMedical.service';
import { MedicalOptionGroupCode } from '@/modules/surgicalEvent';

export class PregnancyInfoService extends PatchableMedicalService<PregnancyInfo> {
  private static INSTANCE_BY_ID: PregnancyInfoService;

  private constructor(patientId: string) {
    super('/pregnancy', patientId);
  }

  public static getInstance(patientId: ID): PregnancyInfoService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new PregnancyInfoService(patientId);
    }

    return this.INSTANCE_BY_ID;
  }

  getFieldOptionGroupMapping(): {
    [k in keyof PregnancyInfo]?: MedicalOptionGroupCode;
  } {
    return {
      foetusPosition: MedicalOptionGroupCode.FOETUS_POSITION,
      placentaPosition: MedicalOptionGroupCode.PLACENTA_POSITION,
      epidural: MedicalOptionGroupCode.EPIDURAL,
      epiduralHo: MedicalOptionGroupCode.EPIDURAL_HO,
      backbone: MedicalOptionGroupCode.BACKBONE,
      cesareanRisk: MedicalOptionGroupCode.CESAREAN_RISK
    };
  }
}
